<template>
	<div class="topic_stat">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">课题统计</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="stat_wrap" v-if="!isShowTableStat">
											<div class="stat_item">
												<div class="item_title">
													<div class="title_left">
														<div class="box"></div>
														<div class="title_text">课题类别统计</div>
													</div>
													<div class="title_right" @click="showTableStat(0)">详细统计</div>
												</div>
												<ul class="data_list">
													<li class="data_item" v-for="(item,index) in topicTypeData" :key="index">
														<div class="data_text">{{item.researchFieName}}</div>
														<div class="data_num">{{item.totalNumber}}个</div>
													</li>
												</ul>
												<div class="item_echart"><TopicTypeStat /></div>
											</div>
											<div class="stat_item">
												<div class="item_title">
													<div class="title_left">
														<div class="box"></div>
														<div class="title_text">课题领域统计</div>
													</div>
													<div class="title_right" @click="showTableStat(1)">详细统计</div>
												</div>
												<ul class="data_list">
													<li class="data_item" v-for="(item,index) in topicDomainData" :key="index">
														<div class="data_text">{{item.researchFieName}}</div>
														<div class="data_num">{{item.totalNumber}}个</div>
													</li>
													
												</ul>
												<div class="item_echart"><TopicDomainStat :data="topicDomainData" /></div>
											</div>
											<div class="stat_item">
												<div class="item_title">
													<div class="title_left">
														<div class="box"></div>
														<div class="title_text">课题学段统计</div>
													</div>
													<div class="title_right" @click="showTableStat(2)">详细统计</div>
												</div>
												<ul class="data_list">
													<li class="data_item" v-for="(item,index) in topicStudyPhaseData" :key="index">
														<div class="data_text">{{item.learningTypeName}}</div>
														<div class="data_num">{{item.totalNumber}}个</div>
													</li>
													
												</ul>
												<div class="item_echart"><TopicStudyPhaseStat :data="topicStudyPhaseData" /></div>
											</div>
											<div class="stat_item">
												<div class="item_title">
													<div class="title_left">
														<div class="box"></div>
														<div class="title_text">课题研究阶段统计</div>
													</div>
													<div class="title_right" @click="showTableStat(3)">详细统计</div>
												</div>
												<ul class="data_list">
													<li class="data_item" v-for="(item,index) in topicResearchPhaseData" :key="index">
														<div class="data_text">{{item.typeName}}</div>
														<div class="data_num">{{item.totalNumber}}个</div>
													</li>
												</ul>
												<div class="item_echart"><TopicResearchPhaseStat :data="topicResearchPhaseData" /></div>
											</div>
											<div class="stat_item">
												<div class="item_title">
													<div class="title_left">
														<div class="box"></div>
														<div class="title_text">按学科统计</div>
													</div>
													<div class="title_right" @click="showTableStat(4)">详细统计</div>
												</div>
												<ul class="data_list1">
													<li class="data_item1" v-for="(item,index) in disciplineData" :key="index">
														<div class="data_text1">{{item.researchFieName}}</div>
														<div class="data_num1">{{item.totalNumber}}个</div>
													</li>
												</ul>
											</div>
											<div class="stat_item">
												<div class="item_title">
													<div class="title_left">
														<div class="box"></div>
														<div class="title_text">按学校统计</div>
													</div>
													<div class="title_right" @click="showTableStat(5)">详细统计</div>
												</div>
												<ul class="data_list">
													<li class="data_item" v-for="(item,index) in schoolData" :key="index">
														<div class="data_text">{{item.unitName}}</div>
														<div class="data_num">{{item.totalNumber}}个</div>
													</li>
													
												</ul>
												<div class="item_echart"></div>
											</div>
										</div>

										<TableStat @goBack="showChartStat" :showIndex="tableStatShowIndex" v-else />
									</div>

									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import Breadcrumb from '../../components/Breadcrumb.vue';
import TopicTypeStat from './components/charts/TopicTypeStat.vue';
import TopicDomainStat from './components/charts/TopicDomainStat.vue';
import TopicStudyPhaseStat from './components/charts/TopicStudyPhaseStat.vue';
import TopicResearchPhaseStat from './components/charts/TopicResearchPhaseStat.vue';
import TableStat from './components/TableStat.vue';
import { topicTypeStat, topicDomainStat, topicStudyPhaseStat, topicResearchPhaseStat, disciplineStat, schoolStat } from '@/api/after/topicManage.js';
export default {
	data() {
		return {
			isShowTableStat: false, //是否显示表格统计
			tableStatShowIndex: 0 ,//显示表格统计的第几个
			topicTypeData:[],//课题类别数据
			topicDomainData:[],//课题领域数据
			topicStudyPhaseData:[],//课题学段数据
			topicResearchPhaseData:[],//课题研究领域数据
			disciplineData:[],//学科数据
			schoolData:[],//学校数据
		};
	},
	components: {
		Breadcrumb,
		TopicTypeStat,
		TopicDomainStat,
		TopicStudyPhaseStat,
		TopicResearchPhaseStat,
		TableStat
	},
	created() {
		// this.topicTypeStat()
		this.topicDomainStat()
		this.topicStudyPhaseStat()
		this.topicResearchPhaseStat()
		this.disciplineStat()
		this.schoolStat()
	},
	methods: {
		// 课题类别统计
		async topicTypeStat(){
			const res = await topicTypeStat()
			if (res.code == 200) {
				this.topicTypeData = res.data
				console.log('课题类别统计',res);
			}else{
				this.$message.error(res.data)
			}
		},
		// 课题领域统计
		async topicDomainStat(){
			const res = await topicDomainStat()
			if (res.code == 200) {
				this.topicDomainData = res.data
				console.log('课题领域统计',res);
			}else{
				this.$message.error(res.data)
			}
		},
		// 课题学段统计
		async topicStudyPhaseStat(){
			const res = await topicStudyPhaseStat()
			if (res.code == 200) {
				this.topicStudyPhaseData = res.data
				console.log('课题学段统计',res);
			}else{
				this.$message.error(res.data)
			}
		},
		// 课题研究阶段统计
		async topicResearchPhaseStat(){
			const res = await topicResearchPhaseStat()
			if (res.code == 200) {
				this.topicResearchPhaseData = res.data
				console.log('课题研究阶段统计',res);
			}else{
				this.$message.error(res.data)
			}
		},
		// 按学科统计
		async disciplineStat(){
			const res = await disciplineStat()
			if (res.code == 200) {
				this.disciplineData = res.data
				console.log('按学科统计',res);
			}else{
				this.$message.error(res.data)
			}
		},
		// 学校统计
		async schoolStat(){
			const res = await schoolStat()
			if (res.code == 200) {
				this.schoolData = res.data
				console.log('学校统计',res);
			}else{
				this.$message.error(res.data)
			}
		},
		// 显示表格统计
		showTableStat(index) {
			this.tableStatShowIndex = index;
			this.isShowTableStat = true;
		},
		// 显示图表统计
		showChartStat() {
			this.isShowTableStat = false;
		}
	}
};
</script>

<style scoped lang="scss">
.stat_wrap {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	.stat_item {
		padding: 10px;
		width: 32%;
		height: 500px;
		margin-bottom: 20px;
		border: 1px solid #f7f7f7;
		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
		.item_title {
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 2px solid #98b8d1;
			font-weight: bold;
			.title_left {
				display: flex;
				align-items: center;
				.box {
					height: 14px;
					width: 4px;
					background-color: #065b9b;
					margin-right: 5px;
				}
				.title_text {
				}
			}
			.title_right {
				cursor: pointer;
			}
		}
		
		.data_list1{
			display: flex;
			flex-wrap: wrap;
			margin-top: 5px;
			.data_item1{
				width: 20%;
				border: 1px solid #e2e2e2;
				margin-bottom: 5px;
				.data_text1{
					border-bottom: 1px solid #e2e2e2;
					text-align: center;
				}
				.data_num1{
					text-align: center;
				}
			}
		}
		
		.data_list {
			.data_item {
				display: flex;
				align-items: center;
				justify-content: space-between;
				height: 30px;
				border-bottom: 1px solid #e2e2e2;
				.data_text {
				}
				.data_num {
				}
			}
		}
		.item_echart {
			width: 100%;
			height: 300px;
		}
	}
}
</style>
